import React from 'react';
import {LinkOutlined} from '@ant-design/icons';
import styles from '@/styles/pages/projects/ProjectCustomPage.module.css';

const STATE_LABELS = {
    running: 'Работает',
    stopped: 'Остановлен',
    warning: 'Требует внимания',
    ondemand: 'По требованию'
};

// Кастомная страница проекта. Структура projects.custom_page:
// { links: [{label, url}], sections: [{title, items: [{name, description, tags, state}]}] }
const ProjectCustomPage = ({page}) => {
    if (!page) return null;
    const links = page.links || [];
    const sections = page.sections || [];

    return (
        <div className={styles.wrapper}>
            {links.length > 0 && (
                <div className={styles.links}>
                    {links.map((link, idx) => (
                        <a key={idx} href={link.url} target="_blank" rel="noopener noreferrer"
                           className={styles.link}>
                            <LinkOutlined/> {link.label}
                        </a>
                    ))}
                </div>
            )}

            {sections.map((section, sIdx) => (
                <section key={sIdx} className={styles.section}>
                    <h3 className={styles.sectionTitle}>
                        {section.title}
                        <span className={styles.count}>{(section.items || []).length}</span>
                    </h3>
                    <div className={styles.grid}>
                        {(section.items || []).map((item, iIdx) => (
                            <div key={iIdx} className={styles.card}>
                                <div className={styles.cardHead}>
                                    <span className={styles.cardName}>{item.name}</span>
                                    {item.state && (
                                        <span className={`${styles.state} ${styles[item.state] || ''}`}>
                                            {STATE_LABELS[item.state] || item.state}
                                        </span>
                                    )}
                                </div>
                                {item.description && <p className={styles.cardText}>{item.description}</p>}
                                {item.tags && item.tags.length > 0 && (
                                    <div className={styles.tags}>
                                        {item.tags.map((tag, tIdx) => (
                                            <span key={tIdx} className={styles.tag}>{tag}</span>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </section>
            ))}
        </div>
    );
};

export default ProjectCustomPage;
